<template>
	<div class="my-table authManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('authManagement.txt1')}} </span>
				<span>{{$t('authManagement.txt2')}} / {{$t('authManagement.txt3')}}</span>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard p30 mt0">
			<div class=" flexCenterBtn">
				<Tag></Tag>
			</div>
			<el-row :gutter="40">
				<el-col :span="12">
					<el-table ref="multipleTable" :data="dataList" v-loading="loading" highlight-current-row 
						@current-change="handleCurrentChange" :default-sort="{prop: 'roleName', order: 'descending'}">
						<el-table-column :label="$t('authManagement.txt4')" type="index" width="50">
						</el-table-column>
						<el-table-column :label="$t('authManagement.txt5')">
							<template slot-scope="scope">
								<span>{{scope.row.roleName?scope.row.roleName:'--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('authManagement.txt6')">
							<template slot-scope="scope">
								<span>{{scope.row.manufacturerName?scope.row.manufacturerName:'--'}}</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="12">
					<div class="treeHeader flexStart">
						<span>{{$t('authManagement.txt7')}}</span>
                        <div class="searchBtn ml20 borderBtn" @click="handleSaveRoleMenu">{{$t('authManagement.txt8')}}</div>
					</div>
					<el-tree :data="menuTree" :default-expanded-keys="['0']" :check-strictly="isCheck" show-checkbox ref="tree" :default-checked-keys="topDot"
						node-key="id" :props="defaultProps">
					</el-tree>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import Tag from './components/tag.vue';
	import qs from 'qs';
	import menuMixin from './menuMixin';
	export default {
		components: {
			Tag
		},
		mixins: [menuMixin],
		data() {
			return {
				isCheck: false,
				topDot: [], //树节点
				menuTree: [], //树形结构
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				//用于获取数据列表
				queryInfo: {
					cmptName: '',
					endCreateTm: '',
					pageNum: 1,
					pageSize: 10,
					productTmplCmptId: '',
					projName: '',
					spvTm: '',
					startCreateTm: '',
					submitterName: '',
					witnCde: '',
					witnType: '',
				},
				dataList: [],
				total: 0,
                loading: false,
			};
		},
		created() {
            this.getMenuTree()
		},
		methods: {
            async getMenuTree() {
                const { data: res } = await this.$http.post("/menu/getMenuTree");
                let menuTree = [];
                menuTree.push({
                    name: this.$t('authManagement.txt9'),
                    children: res.result,
                    id: '0',
                })
                this.menuTree = menuTree
                this.loadData()
            },
			// 数据加载(角色管理列表)
			async loadData(id = '') {
                this.loading = true
				const { data: res } = await this.$http.post("/role/list");
				this.loading = false;
                if (!res.success) {
					return this.$message.error(res.message);
				}
				this.dataList = res.result;
				this.total = res.result.length;
				this.isCheck= true;
				console.log(this.isCheck,'this.isCheck1');
				this.$nextTick(() => {
                    if(id) {
                        let item = this.dataList.find(item => item.id == id)
                        this.$refs.multipleTable.setCurrentRow(item);
                        this.setTreeChecked(item)
                        return 
                    }
                    if(this.dataList[0]) {
					    this.$refs.multipleTable.setCurrentRow(this.dataList[0]);
                        this.setTreeChecked(this.dataList[0])
                    }
					this.isCheck= false;
					console.log(this.isCheck,'this.isCheck2');
				})
			},
            setTreeChecked(item) {
                if(item && item.menuList) {
                    this.$refs.tree.setCheckedKeys(item.menuList.map(item =>item.id))
                }
            },
			handleCurrentChange(val) {
				this.currentRow = val;
                this.setTreeChecked(val)
			},
            async handleSaveRoleMenu() {
				const checkedkeys = this.$refs.tree.getHalfCheckedKeys()
                //子节点的权限id
                const id = this.$refs.tree.getCheckedKeys()
                let ids = checkedkeys.concat(id);
				ids.shift();
                const data = {
                    roleId: this.currentRow.id,
                    menuIds: ids.join(','),
                }
				const { data: res } = await this.$http.post("/role/addMenu?" + qs.stringify(data));
                if(!res.success) {
                    this.$message.warning(res.message)
                }
                this.$message.success(this.$t('authManagement.txt10'))
                // this.loadData(this.currentRow.id)
            },
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style lang="less" scoped>
	.authManagementPage {
		/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
			background: none;
		}
		/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
			background: none;
		}
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}

		.treeHeader {
			border-bottom: 1px solid #EDEFF4;
			padding: 1.5rem 0;
			font-size: 1.6rem;
			font-weight: 400;
			color: #333333;
			margin-bottom: 2.1rem;
			span{
				color:  #1B3B7C;
				font-size: 14px;
			}
		}

		.w32 {

			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}
		}

		.mb15 {
			margin-bottom: 1.5rem;
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}

		.tips {
			font-size: 1.4rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #98B9FF;
			margin-top: -10px;
		}
	}
</style>
